import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import DataTable from "../../common/components/DataTable";
import useCredentials from "../../common/hooks/credentialsHook";
import useNetwork from "../../common/hooks/networkHook";
import { canCreateJobTag, canRemoveJobTag, canUpdateJobTag, createJobTag, removeJobTag, updateJobTag, useJobTags } from "../../reducers/jobTagSlice";
import { SettingsDisplay } from "../../common/components/SettingsPanels";
import PropTypes from 'prop-types';

const defaultSort = ['tag']

const JobTags = ({ uuid, label, onClose }) => {
    const { t } = useTranslation();
    const credentials = useCredentials();
    const network = useNetwork();
    const jobTags = useJobTags();

    const tableDef = useMemo(() => [
        { type: "text", editable: true, field: "tag", title: t('jobTag', { count: jobTags.length }) }
    ], [t, jobTags]);

    const canCreate = canCreateJobTag(credentials);
    const canUpdate = canUpdateJobTag(credentials);
    const canRemove = canRemoveJobTag(credentials);

    return <SettingsDisplay uuid={uuid} title={label} onClose={onClose}>
        <DataTable value={jobTags} columns={tableDef} defaultSort={defaultSort} disabled={!canUpdate} disableAdd={!canCreate} disableRemove={!canRemove} 
            csvFilename={t('jobTag', { count: jobTags.length }) + '.csv'}
            showFilter={true}
            confirmDelete={true}
            onAdd={tag => createJobTag(network, tag)} onUpdate={(tag, field, value) => updateJobTag(network, { id: tag.id, [field]: value })}
            onRemove={tag => removeJobTag(network, tag)}>
        </DataTable>
    </SettingsDisplay>
}
JobTags.propTypes = {
    /**
     * ID to identify the settings status entry
     */
    uuid: PropTypes.string.isRequired,
    /**
     * Label for the screen
     */
    label: PropTypes.string.isRequired,
    /**
     * Function to call when the screen is closed
     */
    onClose: PropTypes.func
}

export default JobTags;